<form class="customer-form flex-grow" [formGroup]="customerForm" (ngSubmit)="onSubmit()">
  <h3>Kundedata</h3>
  <div class="flex flex-col">
    <div class="mb-2">
      <label>Kundetype: </label>
      <mat-radio-group formControlName="customerType" class="mb-1" (change)="customerTypeChange($event.value)">
        <mat-radio-button value="private">Privat</mat-radio-button>
        <mat-radio-button value="business">Erhverv</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="grid grid-cols-2 gap-2">
      <mat-form-field appearance="outline" class="full-width mb-2" [subscriptSizing]="'dynamic'">
        <mat-label>Telefon</mat-label>
        <input matInput formControlName="phoneNumber" placeholder="Indtast telefonnummer" type="tel" autofocus>
      </mat-form-field>
      <mat-form-field appearance="outline" class="full-width mb-2" [subscriptSizing]="'dynamic'">
        <mat-label>E-mail</mat-label>
        <input matInput formControlName="email" placeholder="Indtast e-mail" type="email">
        @if (customerForm.get('email')?.errors?.['email']) {
          <mat-error>Indtast venligst en gyldig e-mail</mat-error>
        }
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width mb-4" [subscriptSizing]="'dynamic'">
      <mat-label>{{isBusinessCustomer() ? 'Kontaktperson' : 'Navn' }}</mat-label>
      <input matInput formControlName="fullName" placeholder="Indtast navn">
    </mat-form-field>

    @if (isBusinessCustomer()) {
      <div class="company-form">
        <h4>Firmaoplysninger</h4>
        <div class="grid grid-cols-2 gap-2">
          <mat-form-field appearance="outline" class="mb-2" [subscriptSizing]="'dynamic'">
            <mat-label>CVR</mat-label>
            <input matInput formControlName="cvr" placeholder="Indtast CVR" (input)="cvrChange($event)">
          </mat-form-field>
          <mat-form-field appearance="outline" class="mb-2" [subscriptSizing]="'dynamic'">
            <mat-label>EAN</mat-label>
            <input matInput formControlName="ean" placeholder="Indtast EAN">
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="mb-2" [subscriptSizing]="'dynamic'">
          <mat-label>Firmanavn</mat-label>
          <input matInput formControlName="companyName" placeholder="Indtast firmanavn">
          @if (loadingCompany()) {
            <mat-spinner matSuffix diameter="20" class="me-4"></mat-spinner>
          }
        </mat-form-field>
      </div>
    }

    <div class="address-form">
      <h4>Adresse</h4>
      <div class="grid grid-cols-2 gap-2">
        <mat-form-field appearance="outline" class="full-width mb-2" [subscriptSizing]="'dynamic'">
          <mat-label>Adresse</mat-label>
          <input matInput formControlName="address" placeholder="Indtast adresse">
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width mb-2" [subscriptSizing]="'dynamic'">
          <mat-label>Land</mat-label>
          <mat-select formControlName="country" placeholder="Vælg land" value="DK">
            <mat-option value="DK">Danmark</mat-option>
            <mat-option value="NO">Norge</mat-option>
            <mat-option value="SE">Sverige</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="grid grid-cols-2 gap-2">
        <mat-form-field appearance="outline" class="mb-2" [subscriptSizing]="'dynamic'">
          <mat-label>Postnummer</mat-label>
          <input matInput formControlName="zipcode" placeholder="Indtast postnummer" (input)="zipcodeChange($event)">
        </mat-form-field>

        <mat-form-field appearance="outline" class="mb-2" [subscriptSizing]="'dynamic'">
          <mat-label>By</mat-label>
          <input matInput formControlName="city" placeholder="Indtast by">
          @if (loadingCity()) {
            <mat-spinner matSuffix diameter="20" class="me-4"></mat-spinner>
          }
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="flex gap-4 justify-end">
    <button mat-flat-button color="warn" type="button" (click)="closeModal()">Annuller</button>
    <button mat-flat-button color="primary" type="submit">
      @if (loading()) {
        <mat-spinner diameter="20" class="spinner-white"/>
      } @else {
        Gem
      }
    </button>
  </div>
</form>
